/* Per-prospect compare panel + drag behaviour.
   Link format: adsvedia.com/?p=mcgarrett#compare
   Optional: &auto=1 runs the slider by itself, for screen recording. */
(function(){
  'use strict';
  var cmp = document.querySelector('.compare');
  if(!cmp) return;

  var params = new URLSearchParams(window.location.search);

  /* ---- swap in the prospect's own ad ---- */
  var key = (params.get('p') || '').toLowerCase().trim();
  if(key){
    var holder = document.querySelector('[data-prospects]');
    var data = {};
    if(holder){
      try { data = JSON.parse(holder.textContent || '{}'); } catch(e){ data = {}; }
    }
    var hit = data[key];
    if(hit && hit.img){
      var pane  = cmp.querySelector('[data-typical]');
      var img   = cmp.querySelector('[data-left-img]');
      var label = cmp.querySelector('[data-left-label]');
      img.addEventListener('load', function(){
        img.hidden = false;
        pane.setAttribute('data-has-image', 'true');
      });
      img.src = hit.img;
      if(hit.label && label){ label.textContent = hit.label; }
    }
  }

  /* ---- drag ---- */
  var setPos = function(pct){
    pct = Math.max(4, Math.min(96, pct));
    cmp.style.setProperty('--pos', pct + '%');
    cmp.setAttribute('aria-valuenow', Math.round(pct));
  };
  var fromX = function(clientX){
    var r = cmp.getBoundingClientRect();
    setPos(((clientX - r.left) / r.width) * 100);
  };
  var dragging = false;
  var start = function(e){ dragging = true; stopAuto(); fromX(e.touches ? e.touches[0].clientX : e.clientX); };
  var move  = function(e){ if(!dragging) return; fromX(e.touches ? e.touches[0].clientX : e.clientX); };
  var stop  = function(){ dragging = false; };
  cmp.addEventListener('mousedown', start);
  window.addEventListener('mousemove', move);
  window.addEventListener('mouseup', stop);
  cmp.addEventListener('touchstart', start, { passive: true });
  cmp.addEventListener('touchmove', move, { passive: true });
  cmp.addEventListener('touchend', stop);
  cmp.addEventListener('keydown', function(e){
    var cur = parseFloat(cmp.style.getPropertyValue('--pos')) || 50;
    if(e.key === 'ArrowLeft'){ cur -= 4; } else if(e.key === 'ArrowRight'){ cur += 4; } else { return; }
    e.preventDefault();
    stopAuto();
    setPos(cur);
  });

  /* ---- ?auto=1 sweeps the handle so you can screen record hands-free ---- */
  var timer = null;
  function stopAuto(){ if(timer){ clearInterval(timer); timer = null; } }
  if(params.get('auto') === '1'){
    var t = 0;
    timer = setInterval(function(){
      t += 0.02;
      /* ease back and forth between 12% and 88% */
      var wave = (Math.sin(t) + 1) / 2;
      setPos(12 + wave * 76);
    }, 16);
  }
})();
